import EntityList from './EntityList';

export default EntityList;


// WEBPACK FOOTER //
// ./app/components/Entities/index.js